import {
    FETCH_STATEMENTS_REQUEST,
      FETCH_STATEMENTS_SUCCESS,
      FETCH_STATEMENTS_FAILURE,
    } from "./FetchStatementsTypes";
    import api from "../../utils/Api";
    
    export const fetchStatementsRequest = () => {
      return {
        type: FETCH_STATEMENTS_REQUEST,
      };
    };
    
    export const fetchStatementsSuccess = (statementsList) => {
      return {
        type: FETCH_STATEMENTS_SUCCESS,
        payload: statementsList,
      };
    };
    
    export const fetchStatementsFailure = (error) => {
      return {
        type: FETCH_STATEMENTS_FAILURE,
        payload: error,
      };
    };
    
    export const fetchStatementsListing = (sortBy, page, payload, paymentForType) => {
    
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "payment/statement/fetch?pageSize=10&page=" + page + "&sort_by=" + sortBy + "&paymentForType="+paymentForType;
      if(payload && payload.practitioner_id){
        url += "&practitioner_id=" + payload.practitioner_id;
      }
      if(payload && payload.patient_id){
        url += "&patient_id=" + payload.patient_id;
      }
      if(payload && payload.invoice_number){
        url += "&invoice_number=" + payload.invoice_number;
      }
      if(payload && payload.membership_number){
        url += "&membership_number=" + payload.membership_number;
      }
      if(payload && payload.supplier_id){
        url += "&supplier_id=" + payload.supplier_id;
      }
      if(payload && payload.dateFrom && Number(paymentForType) === 1){
        url += "&service_date=gte:" + payload.dateFrom;
      }
      if(payload && payload.dateTo && Number(paymentForType) === 1){
        url += "&service_date=lte:" + payload.dateTo;
      }
      if(payload && payload.dateFrom && Number(paymentForType) === 2){
        url += "&payment_date=gte:" + payload.dateFrom;
      }
      if(payload && payload.dateTo && Number(paymentForType) === 2){
        url += "&payment_date=lte:" + payload.dateTo;
      }
    
      
      return async (dispatch) => {
        dispatch(fetchStatementsRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const statementsList = response.data.data;
          dispatch(fetchStatementsSuccess(statementsList));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchStatementsFailure(errorMsg));
        }
      };
    };
    